import { useEffect, useState } from "react";
import { toast } from "sonner";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import api, { apiError } from "./api";

const describe = (entry) => {
  const { method, path } = entry;
  const parts = path.split("/");
  const entity = parts[0];
  const sub = parts.slice(1).join("/");
  if (path === "settings/company") return "Updated company profile (bank document settings)";
  if (path === "users/me/signature") return "Uploaded scanned signature";
  if (path === "auth/change-password") return "Changed own password";
  if (path === "auth/forgot-password") return "Requested a password reset";
  if (path === "auth/reset-password") return "Reset password via email link";
  if (entity === "users") {
    if (method === "POST" && sub.includes("reset-password")) return "Reset a user's password";
    if (method === "POST") return "Created a user";
    if (method === "PUT") return "Updated a user";
    if (method === "DELETE") return "Deleted a user";
  }
  if (entity === "vendors") {
    if (method === "POST") return "Added a vendor";
    if (method === "PUT") return "Edited a vendor";
    if (method === "DELETE") return "Deleted a vendor";
  }
  if (entity === "tds") {
    if (method === "POST") return "Added a TDS option";
    if (method === "PUT") return "Edited a TDS option";
    if (method === "DELETE") return "Deleted a TDS option";
  }
  if (entity === "cases") {
    if (method === "POST" && !sub) return "Created a case";
    if (sub.includes("invoices") && method === "POST") return "Uploaded an invoice";
    if (sub.includes("invoices") && method === "PUT") return "Edited invoice details";
    if (sub.includes("invoices") && method === "DELETE") return "Removed an invoice";
    if (sub.includes("tds-docs")) return method === "POST" ? "Added a TDS supporting document" : "Removed a TDS supporting document";
    if (sub.includes("commercial")) return "Edited TDS / calculation details";
    if (sub.includes("doc-overrides")) return "Edited bank document fields";
    if (sub.includes("generate-docs")) return "Generated the 3 bank documents";
    if (sub.includes("transfer")) return "Transferred case to Commercial";
    if (sub.includes("authorise-for-accounts")) return "Authorised case for Accounts";
    if (sub.includes("authorise")) return "Authorised & stamped the bill";
    if (sub.includes("pass-to-accounts")) return "Passed bill to Accounts (signature applied)";
    if (sub.includes("approve")) return "Approved for authorisation";
    if (sub.includes("close")) return "Closed the case";
    if (method === "DELETE") return "Deleted the case";
    if (method === "PUT") return "Edited case details";
  }
  return `${method} ${path}`;
};

export default function AuditLog() {
  const [entries, setEntries] = useState(null);

  useEffect(() => {
    api.get("/audit").then((r) => setEntries(r.data)).catch((e) => toast.error(apiError(e)));
  }, []);

  return (
    <div data-testid="qc-audit-page">
      <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-[#8A9A91]">Administration</p>
      <h1 className="mt-2 font-display text-3xl font-semibold tracking-tight">Audit Log</h1>
      <p className="mt-1 text-sm text-[#8A9A91]">Every change made in the QC app, with who made it and when.</p>

      <div className="mt-6 overflow-hidden rounded-2xl border border-[#E8E6E1] bg-white">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>When</TableHead>
              <TableHead>Who</TableHead>
              <TableHead>Action</TableHead>
              <TableHead>Reference</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {(entries || []).map((e) => (
              <TableRow key={e.id} data-testid={`qc-audit-row-${e.id}`}>
                <TableCell className="whitespace-nowrap text-[#8A9A91]">
                  {new Date(e.at).toLocaleString("en-IN")}
                </TableCell>
                <TableCell>
                  <p className="font-medium">{e.user_name}</p>
                  <p className="text-xs text-[#8A9A91]">{e.user_email}</p>
                </TableCell>
                <TableCell className="text-sm">{describe(e)}</TableCell>
                <TableCell className="text-sm text-[#8A9A91]">{e.ref || "—"}</TableCell>
              </TableRow>
            ))}
            {entries && entries.length === 0 && (
              <TableRow><TableCell colSpan={4} className="py-10 text-center text-sm text-[#8A9A91]">No activity logged yet.</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
